import { useRef } from "react"
import styled from "styled-components"

export type ScrollAreaProps = {
  children: React.ReactNode
  onScrollToBottom?: () => void
  scrollBottomThreshold?: number
  onScrollToTop?: () => void
  scrollTopThreshold?: number
  className?: string
}

export function ScrollArea({
  children,
  onScrollToBottom,
  scrollBottomThreshold = 0,
  onScrollToTop,
  scrollTopThreshold = 0,
  className,
}: ScrollAreaProps) {
  const hasScrolledToBottom = useRef(false)
  const hasScrolledToTop = useRef(false)

  function handleScroll(event: React.UIEvent<HTMLDivElement>) {
    const { scrollHeight, scrollTop, clientHeight } = event.currentTarget
    const scrollBottom = Math.floor(scrollHeight - (scrollTop + clientHeight))

    if (scrollBottom <= scrollBottomThreshold) {
      if (!hasScrolledToBottom.current) {
        onScrollToBottom?.()
        hasScrolledToBottom.current = true
      }
    } else {
      hasScrolledToBottom.current = false
    }

    if (scrollTop <= scrollTopThreshold) {
      if (!hasScrolledToTop.current) {
        onScrollToTop?.()
        hasScrolledToTop.current = true
      }
    } else {
      hasScrolledToTop.current = false
    }
  }

  return (
    <Container onScroll={handleScroll} className={className}>
      {children}
    </Container>
  )
}

const Container = styled.div`
  height: 100%;
  overflow-y: auto;
`
